export default __webpack_public_path__ + "d804f57f50db1ad710f291d6b556965c.webp";